module.exports = __webpack_public_path__ + "img/product_29.db1ffbf.webp";